// extracted by mini-css-extract-plugin
export default {"wrapper":"Config_wrapper__64h6k","sectionText":"Config_sectionText__wL1WY"};